// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  worldId: __t.u64().name("world_id"),
  posX: __t.f32().name("pos_x"),
  posY: __t.f32().name("pos_y"),
  posZ: __t.f32().name("pos_z"),
  yaw: __t.f32(),
  savedAt: __t.timestamp().name("saved_at"),
});
